import api from './api';

export default class Login {
    async login(email, senha) {
        try {
            const response = await api.post('/login/estabelecimento', { email, senha });
            return response;
        } catch (error) {
            console.log(error);
        }
    }
}